import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../../../utilz';
import { setAppLoader } from '../../../common/CommonActions';
import {
  createProcurementLocationInFail,
  createProcurementLocationInSuccess,
  getProcurementLocationListInFail,
  getProcurementLocationListInSuccess,
} from './ProcurementLocationActions';
import { getLocationListEffect, saveUpdateLocationEffect } from './ProcurementLocationEffects';
import ProcurementLocationType from './ProcurementLocationTypes';

export const procurementLocation = (state) => state.procurementLocation;

function removeEmptyObjects(obj) {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      removeEmptyObjects(obj[key]);
    } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

function* getRouteLocationListAction() {
  try {
    const { locationListReq } = yield select(procurementLocation);
    const requestParams = yield call(removeEmptyObjects, locationListReq);
    const { data } = yield call(getLocationListEffect, requestParams);
    yield put(getProcurementLocationListInSuccess({ data: data }));
  } catch (e) {
    yield put(getProcurementLocationListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* createUpdateProcurementLocationAction(payload) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(saveUpdateLocationEffect, payload?.payload || {});

    if (data.success && data?.valid) {
      if (data?.unSavedLocations === 1) {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.ERROR,
          message: data?.message,
        });
      } else {
        yield call(showNotification, {
          type: NOTIFICATION_TYPES.SUCCESS,
          message:
            payload?.payload?.[0]?.isNew === true ? 'Added Location successfully' : 'Update Location Successfully',
        });
        yield put(createProcurementLocationInSuccess({ data: true }));
      }
    }
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(setAppLoader(false));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: payload?.payload?.[0]?.isNew === true ? 'Create location error' : 'Update location error',
    });
    yield put(createProcurementLocationInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* procurementLocationSaga() {
  yield takeEvery(ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST, getRouteLocationListAction);

  yield takeEvery(ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION, createUpdateProcurementLocationAction);
}
